// i18n area 'tasks' — locale no-NO (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.no-NO.meta.json.
import type { enUS } from './tasks'

export const noNO: typeof enUS = {
  macrotasks: {
    title: 'Macrotasks',
    subtitle: 'Sammensatte operasjoner — gjenopptagbare fra det feilede steget, eller abortérbare',
    colType: 'Type',
    colTarget: 'Objekt',
    colPhase: 'Fase',
    colSteps: 'Steg',
    empty: 'Ingen macrotask',
    detail: 'Detaljer',
    failedAt: 'feilet ved',
    resume: 'Prøv igjen fra det feilede steget',
    abort: 'Avbryt alt',
    cancel: 'Slett',
    actionError: 'Handlingen ble avvist'
  },
  tasks: {
    title: 'Tasks',
    searchPlaceholder: 'Søk etter type eller target',
    type: 'Type',
    target: 'Target',
    phaseLabel: 'Fase',
    progress: 'Fremdrift',
    started: 'Startet',
    finished: 'Fullført',
    node: 'Node',
    empty: 'Ingen task',
    loadError: 'Kunne ikke laste taskene — er TVirt-backenden tilgjengelig?',
    limboHint: "Noden '{node}' har vært utilgjengelig siden {time} — tasken holder write-leasen på targetet sitt til noden kommer tilbake eller attesteres avslått",
    nodeAttested: 'Node attestert avslått',
    phase: {
      queued: 'I kø',
      running: 'Kjører',
      succeeded: 'Fullført',
      failed: 'Feilet',
      cancelled: 'Avbrutt',
      'failed-at-step': 'Feilet ved et steg',
      aborted: 'Abortert'
    },
    dropdown: {
      tooltip: 'Tasks i gang',
      title: 'Tasks i gang',
      empty: 'Ingen task i gang',
      viewAll: 'Se alle tasks'
    },
    detail: {
      open: 'Detaljer',
      scope: 'Område',
      message: 'Melding',
      params: 'Parametere',
      result: 'Resultat',
      errorTitle: 'Feil',
      steps: 'Steg',
      failedAt: 'feilet ved',
      superseded: 'forbigått',
      step: 'Steg',
      parent: 'Parent-task',
      failedStep: 'Feilet steg',
      log: 'Logg',
      logEmpty: 'Ingen logglinje ennå',
      close: 'Lukk'
    },
    actions: {
      cancel: 'Slett',
      resume: 'Prøv igjen fra det feilede steget',
      abort: 'Avbryt alt (undo av de fullførte stegene)',
      refused: 'Handlingen ble avvist'
    }
  },
  events: {
    loadError: 'Kunne ikke laste journalen — er TVirt-backenden tilgjengelig?',
    title: 'Hendelser',
    subtitle: 'Klyngens historiske hukommelse: fullbyrdede fakta, nyeste først',
    filterSeverity: 'Alvorsgrad',
    filterCategory: 'Kategori',
    filterAll: 'Alle',
    searchLabel: 'Søk',
    searchPlaceholder: 'Søk i hele journalen',
    subjectFilter: 'Hendelser for {subject} — vis alle',
    colAt: 'Når',
    colSeverity: 'Alvorsgrad',
    colType: 'Type',
    colSubject: 'Objekt',
    colActor: 'Hvem',
    colNode: 'Node',
    colMessage: 'Melding',
    empty: 'Ingen hendelser',
    loadMore: 'Last flere',
    actorSystem: 'system',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'Hendelses-ID',
    taskCollectedHint: 'Task har kortere oppbevaring: når den er samlet inn, svarer ikke lenken lenger',
    severity: {
      info: 'Info',
      warning: 'Advarsel',
      error: 'Feil',
      critical: 'Kritisk'
    },
    category: {
      lifecycle: 'Livssyklus',
      config: 'Konfigurasjon',
      availability: 'Tilgjengelighet',
      security: 'Sikkerhet'
    },
    type: {
      haNetsvcFailedOver: 'Failover av nettverkstjenesten',
      haNetsvcNoCandidate: 'Nettverkstjeneste uten kandidatnode',
      haNetsvcReaped: 'Lokal instans høstet ved gjeninntreden',
      netsvcFloatipMoved: 'Flytende IP flyttet til en annen holder',
      netsvcFloatipNoHolder: 'Flytende IP uten friskt mål',
      haAppFailedOver: 'Failover av App-instans',
      haAppNoCandidate: 'App-instans uten kandidatnode',
      haAppStorageLocalSkip: 'App-instans ikke flyttet: persistente data er lokale på den døde noden',
      haAppReaped: 'App-instansens lokale pod høstet ved retur'
    }
  },
  audit: {
    loadError: 'Kunne ikke laste auditregisteret — er TVirt-backenden tilgjengelig?',
    title: 'Audit',
    subtitle: 'Hvem gjorde hva, når og på hvilket objekt — forsøkte handlinger, avslag inkludert',
    filterOutcome: 'Utfall',
    filterAll: 'Alle',
    filterSudo: 'Bare forhøyede handlinger',
    colAt: 'Når',
    colActor: 'Hvem',
    colAction: 'Handling',
    colTarget: 'Objekt',
    colOutcome: 'Utfall',
    colNode: 'Node',
    empty: 'Ingen registrerte handlinger',
    loadMore: 'Last flere',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Rute',
    detailProblem: 'Årsak',
    detailTask: 'Task',
    detailClientIp: 'Fra',
    detailId: 'Post-ID',
    detailSession: 'Sesjon',
    taskHint: 'Utfallet av en akseptert handling lever i hendelsesjournalen, under samme task-id',
    outcome: {
      succeeded: 'Utført',
      accepted: 'Akseptert',
      denied: 'Nektet',
      rejected: 'Avvist',
      failed: 'Feilet'
    }
  },
  notifications: {
    loadError: 'Kunne ikke laste varslene — er TVirt-backenden tilgjengelig?',
    actionError: 'Handlingen ble avvist',
    title: 'Varsler',
    subtitle: 'Destinasjonene som journalens fakta forlater klyngen mot',
    rulesTitle: 'Regler',
    rulesSubtitle: 'Hvilke fakta som går ut, og hvorhen',
    deliveriesTitle: 'Leveringer',
    deliveriesSubtitle: 'Resultatet av hvert varsel, med årsaken når det feiler',
    colName: 'Navn',
    colKind: 'Type',
    colWhere: 'Hvorhen',
    colScope: 'Scope',
    colSeverity: 'Alvorlighet',
    colMatch: 'Filter',
    colTargets: 'Destinasjon',
    colAt: 'Når',
    colState: 'Tilstand',
    colEvent: 'Hendelse',
    colAttempts: 'Forsøk',
    colOutcome: 'Resultat',
    empty: 'Ingen rad',
    matchAll: 'alle fakta',
    test: 'Test',
    testOk: 'Testvarsel levert til {target}',
    testFailed: 'Test mot {target} mislyktes: {reason}',
    retry: 'Legg i kø igjen',
    retried: 'Levering lagt i kø igjen',
    grouped: 'og {count} flere gjentakelser',
    state: {
      failed: 'Mislykket',
      pending: 'I kø',
      sending: 'Sendes',
      sent: 'Sendt'
    },
    tabTargets: 'Destinasjoner',
    tabRules: 'Regler',
    tabDeliveries: 'Leveringer',
    targetCreateTitle: 'Ny destinasjon',
    ruleCreateTitle: 'Ny regel',
    nameHint: 'Små bokstaver, sifre og bindestrek; unikt per scope',
    kindImmutableHint: 'Uforanderlig: å endre typen betyr å opprette en annen destinasjon',
    kindSmtp: 'Post (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Status',
    enabledOn: 'Aktiv',
    enabledOff: 'Satt på pause',
    smtpHost: 'SMTP-tjener',
    smtpPort: 'Port',
    smtpPortHint: 'Vanlig: 25 uten TLS, 587 med starttls, 465 med tls',
    smtpSecurity: 'Sikkerhet',
    smtpFrom: 'Avsender',
    smtpTo: 'Mottakere',
    smtpToHint: 'En eller flere adresser skilt med komma',
    webhookUrl: 'URL',
    payload: 'Innhold',
    payloadHint: 'Med minimal forlater hendelsens melding og data aldri klyngen',
    credential: 'Legitimasjon',
    credentialNone: 'Ingen',
    credentialHintSmtp: 'Relay-kontoen fra nøkkellageret; ingen betyr anonym SMTP',
    credentialHintWebhook: 'Signeringshemmeligheten fra nøkkellageret; uten signering kan alle som kjenner URL-en utgi seg for å være klyngen',
    minSeverityHint: 'En terskel, ikke en mengde: fra denne alvorsgraden og opp',
    categories: 'Kategorier',
    categoriesHint: 'Tomt = alle',
    types: 'Hendelsestyper',
    typesHint: 'Skilt med komma; tomt = alle. En ukjent type avvises',
    targetsHint: 'Minst én; de må ligge i regelens scope eller i en forfar av det',
    recursiveOn: 'Også underordnede scope',
    recursiveOff: 'Bare dette scope',
    recursiveHint: 'Ressurser lever i bladene: uten barna varsler en regel på roten nesten ingenting',
    repeatWindow: 'Grupperingsvindu (s)',
    repeatWindowHint: 'Innenfor vinduet sender gjentakelser ingen post: de telles på den første. 0 slår av',
    targetInUseError: 'Destinasjonen {name} brukes fortsatt av en regel'
  }
}
